import templateUrl from "./rogers-onboarding-summary.component.html";

export const RogersOnboardingSummaryComponent = {
    templateUrl,
    bindings: {
        report: "<"
    }
};
